var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService, prepareParams, } from "./baseService";
class EmployeeService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "employee";
    }
    setActive(id, isActive) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.put(`/${this.controllerName}/${id}/setActive`, { isActive });
            return data;
        });
    }
    getProfiles(ids, options, forEmployees = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            params[forEmployees ? "employeeIds" : "userIds"] = `[${ids.toString()}]`;
            const { data } = yield this.api.get(`/${this.controllerName}/profile`, { params });
            return data.data;
        });
    }
    getAllWorkShiftsById(employeeId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}/${employeeId}/workshift`, { params });
            return data;
        });
    }
    getAllSupervisors(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            delete this.api.defaults.headers["supervisors-identifiers"];
            const { data } = yield this.api.get(`/${this.controllerName}`, { params });
            return data;
        });
    }
    getAllEmployeesLean(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}/lean`, { params });
            return data;
        });
    }
    getSummaryData(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            if (options === null || options === void 0 ? void 0 : options.category) {
                params.category = options.category;
            }
            if (options === null || options === void 0 ? void 0 : options.startDate) {
                params.startDate = options.startDate;
            }
            if (options === null || options === void 0 ? void 0 : options.endDate) {
                params.endDate = options.endDate;
            }
            const { data } = yield this.api.get(`/${this.controllerName}/summary`, { params });
            return data;
        });
    }
}
export const employeeService = new EmployeeService();
//# sourceMappingURL=employeeService.js.map